import { Subject } from 'rxjs/Subject';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, Input, ViewChild, AfterViewInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Currency } from 'app/model/currency.model';
import { CurrencyService } from 'app/services/currency/currency.service';
import { Subscription } from 'rxjs';

import $ from 'jquery';
import 'jquery-ui/ui/widgets/slider';
import '../../../vendors/jquery.ui.touch-punch.min.js'

@Component({
  selector: 'act-slider-range',
  templateUrl: './slider-range.component.html',
  styleUrls: ['./slider-range.component.scss']
})
export class SliderRangeComponent implements OnInit, AfterViewInit, OnChanges {
  rangeForm: FormGroup;
  @ViewChild('sliderRange') sliderRangeEl;

  @Input() min: number = 0;
  @Input() max: number = 0;
  @Input() minRange: number = 0;
  @Input() maxRange: number = 0;
  @Input() maxDirty = false;
  @Input() minDirty = false;
  @Input() autoSelectAll = true;
  @Input() wrapMaxPrice: boolean = true;

  @Output() rangeChange = new EventEmitter<{
    min: number,
    max: number,
    minDirty: boolean,
    maxDirty: boolean
  }>();
  private $rangeChange = new Subject<{
    min: number,
    max: number,
    minDirty: boolean,
    maxDirty: boolean
  }>();
  private currencySubscription: Subscription;
  private currencyCode: string;

  public displayPostfix = 'Display';

  constructor(
    private formBuilder: FormBuilder,
    private utilitiesService: UtilitiesService,
    private currencyService: CurrencyService) {
    this.rangeForm = this.formBuilder.group({
      'min': this.min,
      'max': this.max,
      'minDisplay': this.transformPriceRangeDisplay(this.min),
      'maxDisplay': this.transformPriceRangeDisplay(this.max)
    });

    this.$rangeChange
      .asObservable()
      .filter(changeItem => !!changeItem)
      .debounceTime(500)
      .subscribe(changeItem => {
        this.rangeChange.emit(changeItem);
      });
      this.onCurrencyChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.sliderRangeEl) {
      if (changes['minRange'] || changes['maxRange'] || changes['min'] || changes['max']) {
        if (!$(this.sliderRangeEl.nativeElement).slider("instance")) {
          this.initSlider();
        }
        this.transformToDisplay('min', this.min);
        this.transformToDisplay('max', this.max);
        this.updateSlider();
      }
    }
  }

  ngOnInit() {}

  onCurrencyChanges() {
    this.currencyCode = this.currencyService.getCurrency().currencyCode;
    this.currencySubscription && this.currencySubscription.unsubscribe();
    this.currencySubscription = this.currencyService.getCurrencyObs().subscribe(val => {
      this.currencyCode = val.currencyCode;
      this.transformToDisplay('min', this.min);
      this.transformToDisplay('max', this.max);
      this.updateSlider();
    });
  }

  ngAfterViewInit() {
    this.initSlider();
  }

  rangeChanged() {
    this.$rangeChange.next({
      min: this.rangeForm.value.min,
      max: this.rangeForm.value.max,
      minDirty: this.minDirty,
      maxDirty: this.maxDirty
    });
  }

  isZeroMinMax() {
    return this.rangeForm.get('min').value === 0 && this.rangeForm.get('max').value === 0;
  }

  onInputFocused(fromControlName: string, ev: Event) {
    this.rangeForm
      .get(fromControlName + this.displayPostfix)
      .setValue(this.rangeForm.get(fromControlName).value);
    this.autoSelectAll && ev && (<HTMLInputElement>ev.target).select();
  }

  onInputBlured(fromControlName: string) {
    let newValue: number = +this.rangeForm.get(fromControlName + this.displayPostfix).value;
    const oldValue: number = +this.rangeForm.get(fromControlName).value;

    if (isNaN(+newValue)) {
      newValue = oldValue;
    }

    switch (fromControlName) {
      case 'min':
        newValue = Math.max(newValue, this.minRange);
        newValue = Math.min(newValue, this.maxRange);
        if (+this.rangeForm.value.max < newValue) {
          this.transformToDisplay('max', newValue);
        }
        break;
      case 'max':
        if (this.wrapMaxPrice) {
          newValue = Math.min(newValue, this.maxRange);
          newValue = Math.max(newValue, this.minRange);
        }
        if (+this.rangeForm.value.min > newValue) {
          this.transformToDisplay('min', newValue);
        }
        break;
    }

    this.transformToDisplay(fromControlName, newValue);
    this.updateSlider();

    if (oldValue !== newValue) {
      this[fromControlName + 'Dirty'] = true;
      this.rangeChanged();
    }
  }

  onInputEnter(ev: Event) {
    (<HTMLInputElement>ev.target).blur();
  }

  defualtTransform(inputVal: number): string {
    return inputVal + '';
  }

  validateNumber(event: KeyboardEvent) {
    return (/\d/.test(String.fromCharCode(event.which)));
  }

  initSlider() {
    $(this.sliderRangeEl.nativeElement).slider({
      range: true,
      min: this.minRange,
      max: this.maxRange,
      values: [
        this.rangeForm.value.min,
        this.rangeForm.value.max
      ],
      slide: (event, ui) => {
        switch (ui.handleIndex) {
          case 0:
            this.transformToDisplay('min', ui.values[ui.handleIndex]);
            this.minDirty = true;
            break;
          case 1:
            this.transformToDisplay('max', ui.values[ui.handleIndex]);
            this.maxDirty = true;
            break;
        }
        this.rangeChanged();
      }
    });
  }

  updateSlider() {
    $(this.sliderRangeEl.nativeElement).slider('option', 'max', this.maxRange);
    $(this.sliderRangeEl.nativeElement).slider('option', 'min', this.minRange);

    $(this.sliderRangeEl.nativeElement).slider(
      'values',
      [this.rangeForm.value.min, this.rangeForm.value.max]);

  }

  transformToDisplay(fromControlName: string, newValue: number) {
    this.rangeForm.get(fromControlName + this.displayPostfix)
      .setValue(this.transformPriceRangeDisplay(newValue));
    this.rangeForm.get(fromControlName)
      .setValue(newValue);
  }

  transformPriceRangeDisplay(inputVal: number) {
    if (this.currencyCode) {
      return this.currencyCode + ' ' + inputVal.toLocaleString();
    }
    return this.utilitiesService.getPriceRangeFormatText(inputVal);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/slider-range/slider-range.component.ts